export type CognitionWsEvent =
  | { type: "analysis_started"; brandName: string; productName: string; totalModels: number; models: string[] }
  | { type: "model_status"; engine: string; status: "queued" | "running" | "done" | "error"; message?: string }
  | { type: "progress"; done: number; total: number; percent: number }
  | { type: "final_result"; data: any; errors?: Record<string, string>; runId?: number; baselineSnapshot?: string }
  | { type: "error"; message: string; errors?: any };

export function openCognitionSocket(opts: {
  baseWsUrl: string;
  token: string;
  payload: any;
  onOpen?: () => void;
  onEvent: (evt: CognitionWsEvent) => void;
  onError?: () => void;
  onClose?: () => void;
}) {
  const ws = new WebSocket(`${opts.baseWsUrl}/cognition/ws/cognition-trace?token=${encodeURIComponent(opts.token)}`);

  ws.onopen = () => {
    opts.onOpen?.();
    ws.send(JSON.stringify(opts.payload));
  };

  ws.onmessage = (ev) => {
    try {
      const parsed = JSON.parse(ev.data);
      opts.onEvent(parsed);
    } catch {
      // ignore malformed
    }
  };

  ws.onerror = () => opts.onError?.();
  ws.onclose = () => opts.onClose?.();

  return ws;
}
